function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.875 0C1.10706 0 1.32962 0.0921874 1.49372 0.256282C1.65781 0.420376 1.75 0.642936 1.75 0.875V6.559L12.7173 0.196C13.6273 -0.3325 14.875 0.27125 14.875 1.414V6.559L25.8423 0.196C26.7523 -0.3325 28 0.27125 28 1.414V14.336C28 15.4788 26.7523 16.0825 25.8423 15.554L14.875 9.191V14.336C14.875 15.4788 13.6273 16.0825 12.7173 15.554L1.75 9.191V14.875C1.75 15.1071 1.65781 15.3296 1.49372 15.4937C1.32962 15.6578 1.10706 15.75 0.875 15.75C0.642936 15.75 0.420376 15.6578 0.256282 15.4937C0.0921873 15.3296 0 15.1071 0 14.875V0.875C0 0.642936 0.0921873 0.420376 0.256282 0.256282C0.420376 0.0921874 0.642936 0 0.875 0V0ZM13.125 1.98275L2.968 7.875L13.125 13.7672V1.98275ZM26.25 1.98275L16.093 7.875L26.25 13.7672V1.98275Z",
  fill: "black"
});

function SvgPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.d4c47e5b.svg";
export { ForwardRef as ReactComponent };